import * as yup from "yup";
import { showDate } from "../../../../../utilities/helper";

export interface EductionalDetailModel {
  id: number;
  qulification: string;
  education_Category_Id: number;
  education_Degree_Id: number;
  course: string;
  university: string;
  grade: string;
  passingYear: string;
  title: string;
}

type EductionalDetailKey = keyof EductionalDetailModel;

interface Item {
  key: EductionalDetailKey;
  label: string;
  modifier?: any;
}

export interface Props {
  employeeId: number | null;
}
export interface CategoryDD {
  id: number;
  educationName: string;
}
export interface DegreeDD {
  id: number;
  degreeName: string;
  isCourseStream: boolean;
}

export interface IEducationDetail {
  education_Category_Id: number;
  education_Degree_Id: number;
  course: string;
  instituteName: string;
  grade: string;
  passingYear: string;
  isCourseStream?: boolean
}


// export const EducationSchema = yup.object({
//     education_Category_Id: yup.number().required("Category is required").typeError("Category is required"),
//     education_Degree_Id: yup.number().required("Degree is required").typeError("Degree is required"),
//     course: yup.string().required("Course/Stream is required").matches(/^[A-Za-z\s]+$/, "Course/Stream can only contain letters and spaces"),
//     instituteName: yup.string().required("Institute Name is required"),
//     grade: yup
//       .string()
//       .required("Grade/Percentage/CGPA is required")
//       .test(
//         "is-valid",
//         "Enter a valid Percentage (0–100) or CGPA (0–10)",
//         (value) => {
//           if (!value) return false;
//           // Percentage: 0 - 100 (with optional decimals, max 2 digits after decimal)
//           const percentageRegex = /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;
//           // CGPA: 0 - 10 (with optional decimals, max 2 digits after decimal)
//           const cgpaRegex = /^(10(\.0{1,2})?|[0-9](\.\d{1,2})?)$/;
//           return percentageRegex.test(value) || cgpaRegex.test(value);
//         }
//       ),
//     passingYear: yup.string().required("Passing Year is required"),
//   });


export const EducationSchema = yup.object({
  education_Category_Id: yup
    .number()
    .required("Category is required")
    .typeError("Category is required"),

  education_Degree_Id: yup
    .number()
    .required("Degree is required")
    .typeError("Degree is required"),

  course: yup.string().when("isCourseStream", {
    is: true,
    then: (schema) =>
      schema.required("Course/Stream is required").matches(/^[A-Za-z\s]+$/, "Course/Stream can only contain letters and spaces"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),

  instituteName: yup.string().required("Institute Name is required"),

  grade: yup.string().required("Grade/Percentage/CGPA is required").test(
    "is-valid", "Enter a valid Percentage (0–100) or CGPA (0–10)",
    (value) => {
      if (!value) return false;
      const percentageRegex =
        /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;

      const cgpaRegex =
        /^(10(\.0{1,2})?|[0-9](\.\d{1,2})?)$/;

      return (
        percentageRegex.test(value) ||
        cgpaRegex.test(value)
      );
    }
  ),

  passingYear: yup
    .string()
    .required("Passing Year is required"),
});


export const EducationDetailHeaders: Item[] = [
  { label: "Qualification", key: "qulification" },
  { label: "Course/Stream", key: "course", modifier: (data: any) => data || "N/A", },
  { label: "University/Institute", key: "university" },
  { label: "Percentage/CGPA", key: "grade" },
  { label: "Passing Year", key: "passingYear", modifier: (data: any) => showDate(data).split("-")?.[2] },
];
